<div class="d-flex flex-column align-items-stretch px-3">
  <div
    class="filter-infos d-flex justify-content-between align-items-center mb-1"
    >
    @if (this.searchModuleIndex == 0) {
      <small translate>SEARCH_LBL_CUSTOM_FILTER</small>
    } @else {
      <span>{{ 'GLOBAL_MSG_OR' | translate | titlecase }}</span>
    }
    <button class="btn btn-outline-dark btn-sm" (click)="removeCustomFilter()">
      <i class="mdi mdi-trash-can-outline"></i>
    </button>
  </div>

  @if (this.view$ | async; as view) {
    <select
      id="propertyId"
      class="form-control form-control-sm mb-2"
      [(ngModel)]="this.domain.field"
      (change)="onFieldSelect()"
      >
      @for (field of view.fields; track field) {
        <option [ngValue]="field.name">
          {{ field.label }}
        </option>
      }
    </select>
  }
  @if (this.operations) {
    <select
      id="operationId"
      class="form-control form-control-sm mb-2"
      [(ngModel)]="this.domain.operator"
      >
      @for (operator of this.operations; track operator) {
        <option [ngValue]="operator">
          {{ operator.label }}
        </option>
      }
    </select>
  }
  <div>
    @switch (this.domain.operator.numberOfValues) {
      @case (0) {
        <div></div>
      }
      @case (1) {
        <div>
          @if (this.currentTypeGroup == 'Text') {
            <input
              type="text"
              class="form-control form-control-sm"
              [(ngModel)]="this.domain.value"
              (ngModelChange)="onNgModelChange($event)"
              />
          }
          @if (this.currentTypeGroup == 'Date' || this.currentTypeGroup == 'DateOnly') {
            <input
              type="date"
              [max]="this.maxDateMaskSafeGuard"
              class="form-control form-control-sm"
              [(ngModel)]="this.dateValue"
              (ngModelChange)="onNgModelChangeOneDate($event, this.currentTypeGroup)"
              />
          }
        </div>
      }
      @case (2) {
        <div>
          <div class="double-input-group d-flex">
            @if (this.currentTypeGroup == 'Text') {
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="this.domain.value"
                (ngModelChange)="onNgModelChange($event)"
                />
            }
            @if (this.currentTypeGroup == 'Date' || this.currentTypeGroup == 'DateOnly' ) {
              <input
                type="date"
                [max]="this.maxDateMaskSafeGuard"
                class="form-control form-control-sm"
                [(ngModel)]="this.dateValue"
                (ngModelChange)="onNgModelChangeTwoDate($event, this.currentTypeGroup)"
                />
            }
            <span class="mx-2 align-self-end" translate>GLOBAL_MSG_AND</span>
            @if (this.currentTypeGroup == 'Text') {
              <input
                type="text"
                class="form-control form-control-sm"
                [(ngModel)]="this.domain.value2"
                (ngModelChange)="onNgModelChange2($event)"
                />
            }
            @if (this.currentTypeGroup == 'Date' || this.currentTypeGroup == 'DateOnly') {
              <input
                type="date"
                [max]="this.maxDateMaskSafeGuard"
                class="form-control form-control-sm"
                [(ngModel)]="this.dateValue2"
                (ngModelChange)="onNgModelChangeTwoDate2($event,this.currentTypeGroup)"
                />
            }
          </div>
        </div>
      }
    }
  </div>
</div>
